// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@insite/content-library/Widgets/Brand/BrandList";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { color } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

listStyles.brandAccordionSection = {
    mergeCss: true,
    headerProps: {
        css: css`
            ${/* sc-selector */ AccordionSectionPanel} + & button {
                border-top: 0;
                &:focus {
                    border-color: ${color("common.border")};
                    border-style: solid;
                    border-width: 1px;
                    padding-top: 7px;
                    border-top: 0;
                }
            }
        `,
    },
    titleTypographyProps: {
        weight: "bold",
        css: css`
            text-transform: uppercase;
        `,
    },
};
